import { Component, OnInit } from '@angular/core';
import { Faculty } from 'src/app/models/faculty.model';
import { FacultyService } from 'src/app/services/faculty/faculty.service';

@Component({
  selector: 'app-political-science',
  templateUrl: './political-science.component.html',
  styleUrls: ['./political-science.component.scss']
})
export class PoliticalScienceComponent implements OnInit {
  political:Faculty[];
  constructor(private facultyService:FacultyService) { }

  ngOnInit(): void {
    this.political=this.facultyService.getPoliticalScience();
  }

}
